import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../../app/store";

export interface UserState {
  token?: string;
  patientId?: string;
  clientId?: number;
  language?: string;
}

const initialState: UserState = {
  token: undefined,
  patientId: undefined,
  clientId: undefined,
  language: undefined,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: (state) => {
      state.token = undefined;
      state.patientId = undefined;
    },
    login: (
      state,
      action: PayloadAction<{ token: string; patientId: string }>
    ) => {
      state.token = action.payload.token;
      state.patientId = action.payload.patientId;
      return state;
    },
    setClientId: (state, action: PayloadAction<number>) => {
      state.clientId = action.payload;
      return state;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
      return state;
    },
  },
});

export const selectPatientId = (state: RootState) => state.user.patientId;
export const selectToken = (state: RootState) => state.user.token;
export const selectClientId = (state: RootState) => state.user.clientId;
export const selectLanguage = (state: RootState) => state.user.language;
export const { logout, login, setClientId, setLanguage } = userSlice.actions;
export default userSlice.reducer;
